import cs from 'classnames'
import React, { CSSProperties, ReactNode } from 'react'

import { markdownify } from '../../utils'
import ButtonActions, { ButtonActionItem } from './ButtonActions'
import * as styles from './Section.module.css'

export interface SectionProps {
  title?: string
  subTitle?: string
  description?: string
  fullWidth?: boolean
  headerCenter?: boolean
  actions?: ButtonActionItem[]
  children: ReactNode
  id?: string
  style?: CSSProperties
  className?: string
}

export default function Section({
  title,
  subTitle,
  description,
  fullWidth,
  headerCenter,
  actions,
  children,
  id,
  style,
  className
}: SectionProps) {
  return (
    <section
      className={`${styles.section} ${className && className}`}
      id={id}
      style={style}
    >
      {title && (
        <header className={`${styles.header} ${headerCenter && styles.center}`}>
          <h2 className={styles.title}>{title}</h2>
          {subTitle && <h3 className={styles.subTitle}>{subTitle}</h3>}
          {description && (
            <div
              className={cs(
                styles.description,
                fullWidth && styles.descriptionFullWidth
              )}
            >
              {markdownify(description)}
            </div>
          )}
          {actions && <ButtonActions actions={actions} />}
        </header>
      )}
      {children}
    </section>
  )
}
